import React from 'react';
import { copyTextButton } from '../../Utils';

// AIDEV-NOTE: dev/demo/staging (and PR envs) sit behind Twingate, so Brightspace can't fetch their /jwks.
// They share one JWT_KEY, whose keyset is published to the teachtci-lti-keysets S3 bucket; re-publish it if the
// key rotates. Env comes from the _slugs partial (Rails.env). Local dev uses ngrok and keeps /jwks.
const S3_KEYSET_URL = 'https://teachtci-lti-keysets.s3.us-east-1.amazonaws.com/jwks.json';
const VPN_ONLY_ENVS = ['dev', 'demo', 'staging'];

const keysetUrl = (rootUrl: string) => {
  const env = document.querySelector<HTMLElement>('#slug-attributes')?.dataset.env;

  return VPN_ONLY_ENVS.includes(env) ? S3_KEYSET_URL : `${rootUrl}jwks`;
};

interface LtiLaunchUrlsProps {
  rootUrl: string;
}

const LtiLaunchUrls = ({ rootUrl }: LtiLaunchUrlsProps) => {
  const launchUrl = `${rootUrl}lti_launch/launch`;
  const rows = [
    { label: 'Domain', value: rootUrl },
    { label: 'Redirect URLs', value: launchUrl },
    { label: 'OpenID Connect Login URL', value: `${rootUrl}lti_launch/openid` },
    { label: 'Target Link URI', value: launchUrl },
    { label: 'Keyset URL', value: keysetUrl(rootUrl) },
  ];

  return (
    <div className="tw-mb-4">
      <p className="tw-mb-5">Register TCI as an LTI tool in Brightspace using these values:</p>
      <dl className="tw-grid tw-grid-cols-[max-content_1fr_auto] tw-items-center tw-gap-x-6 tw-gap-y-3 tw-m-0">
        {rows.map(({ label, value }) => (
          <React.Fragment key={label}>
            <dt className="tw-font-bold">{label}</dt>
            <dd className="tw-m-0 tw-font-mono tw-text-sm tw-break-all">{value}</dd>
            <dd className="tw-m-0 tw-text-right">{copyTextButton(value)}</dd>
          </React.Fragment>
        ))}
      </dl>
    </div>
  );
};

export default LtiLaunchUrls;
